<script setup>
import { Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineProps({ property: { type: Object, required: true } })
</script>

<template>
  <Link :href="`/properties/${property.id}`" class="card">
    <div class="card__photo">
      <img v-if="property.photo_url" :src="property.photo_url" :alt="property.title">
      <div v-else class="card__photo-placeholder">{{ property.title?.[0] }}</div>
    </div>
    <div class="card__body">
      <h3 class="card__title">{{ property.title }}</h3>
      <p class="card__meta">
        {{ t(`host_portal.property.categories.${property.category}`) }}
        <template v-if="property.area"> · {{ property.area }}</template>
        <template v-if="property.price_per_night"> · {{ property.price_per_night }}{{ t('host_portal.property.per_night_short') }}</template>
      </p>
      <div class="card__pills">
        <span class="pill" :class="`pill--status-${property.status}`">{{ t(`host_portal.property.status.${property.status}`) }}</span>
        <span class="pill" :class="`pill--approval-${property.approval_state}`">{{ t(`host_portal.property.approval.${property.approval_state}`) }}</span>
      </div>
    </div>
  </Link>
</template>

<style scoped>
.card { display: block; background: var(--surface); border: 1px solid var(--line); border-radius: 0.75rem; text-decoration: none; color: inherit; overflow: hidden; transition: border-color 150ms ease; }
.card:hover { border-color: color-mix(in oklch, var(--accent) 60%, var(--line)); }
.card__photo { aspect-ratio: 4 / 3; background: var(--surfaceAlt); display: grid; place-items: center; overflow: hidden; }
.card__photo img { width: 100%; height: 100%; object-fit: cover; }
.card__photo-placeholder { font-size: 3rem; font-weight: 700; color: var(--muted); }
.card__body { padding: 0.75rem 0.875rem 0.875rem; }
.card__title { margin: 0 0 0.25rem; font-size: 0.9375rem; color: var(--ink); font-weight: 600; }
.card__meta { margin: 0 0 0.5rem; font-size: 0.8125rem; color: var(--muted); }
.card__pills { display: flex; flex-wrap: wrap; gap: 0.35rem; }
.pill { display: inline-block; padding: 0.15rem 0.55rem; border-radius: 999px; font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
.pill--status-active   { background: color-mix(in oklch, var(--ok) 14%, var(--surface)); color: var(--ok); }
.pill--status-inactive { background: color-mix(in oklch, var(--muted) 14%, var(--surface)); color: var(--muted); }
.pill--status-retired  { background: color-mix(in oklch, var(--danger) 12%, var(--surface)); color: var(--danger); }
.pill--approval-approved { background: color-mix(in oklch, var(--ok) 14%, var(--surface)); color: var(--ok); }
.pill--approval-pending  { background: color-mix(in oklch, var(--warn) 14%, var(--surface)); color: var(--warn); }
.pill--approval-rejected { background: color-mix(in oklch, var(--danger) 14%, var(--surface)); color: var(--danger); }
</style>
